<annotation-filter [content]="content()" [forceUpdate]="contentUpdateHash()"></annotation-filter>
